<template>
    <div class="form-builder-breadcrumbs">
        <div class="form-builder-breadcrumbs-path">
            <div class="form-builder-breadcrumbs-path-inner">
                <div class="form-builder-breadcrumbs-path-progress" :style="{width:progress}"></div>
            </div>
        </div>
        <div class="form-builder-breadcrumbs-step" :class="{current:index == currentStep,active:index < currentStep}" v-for="(step,index) in steps">
            <div class="form-builder-breadcrumbs-step-number" @click="handleStep(index)">{{ index + 1 }}</div>
            <div class="form-builder-breadcrumbs-step-label">{{ step.label }}</div>
        </div>
    </div>
</template>


<script>
    //import Component from 'path/to/component'
    import {mapGetters} from 'vuex'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {
            ...mapGetters({
                currentStep: 'Plugins/currentStep'
            }),
            progress(){

                console.log('PROGRESS',this.currentStep,this.steps.length,(this.currentStep * 100 / this.steps.length) )
                return (this.currentStep * 100 / (this.steps.length - 1)) + '%'
            }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            handleStep(index){
                if(index < this.currentStep){
                    this.$emit('step',index)
                }
            }
        },
        mounted: function () {

        },
        name: '',
        props: {
            steps: {
                type:Array,
                required: true
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">

    .form-builder-breadcrumbs{
        display: flex;
        max-width: 700px;
        margin: 20px auto 0;
        width: auto;
        position: relative;

        .form-builder-breadcrumbs-path{
            position: absolute;
            height: 5px;
            width: 100%;
            top: 17.5px;
            z-index: 0;
            padding: 0 100px;

            .form-builder-breadcrumbs-path-inner{
                position: relative;
                background-color: #D6D6D6;
                //background-color: red;
                width: 100%;
                height: 100%;

                .form-builder-breadcrumbs-path-progress{
                    background-color: $secondary-color;
                    position: absolute;
                    height: 100%;
                    transition: width 300ms ease-out;
                }
            }
        }

        .form-builder-breadcrumbs-step{
            flex: 0 1 100%;
            text-align: center;
            position: relative;
            width: 200px;
            z-index: 1;

            .form-builder-breadcrumbs-step-number{
                width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 4px;
                background-color: #D6D6D6;
                color: #FFFFFF;
                font-weight: $bold;
                font-size: 24px;
                margin: auto;
            }
            .form-builder-breadcrumbs-step-label{
                font-size: 0.8rem;
                margin-top: 8px;
            }

            &.active{

                .form-builder-breadcrumbs-step-number{
                    background-color: $secondary-color;
                    cursor: pointer;
                }


            }

            &.current{
                .form-builder-breadcrumbs-step-number{
                    background-color: $main-color;
                }
                .form-builder-breadcrumbs-step-label{
                    font-weight: $bold;
                }

            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/Breadcrumbs.vue